import { DataStore, ItemReference, DataModel, Query, QueryResult } from 'src/core/stores/dataStore';
import { FormStore, FormModel } from 'src/core/stores/formStore';
import { repository, AsyncAction, reduce } from 'redux-scaffolding-ts';
import { container } from 'src/inversify.config';
import { Validator } from "lakmus";
import { CommandResult } from '../core/stores/types';
import { AxiosResponse } from 'axios';
import HttpService from '../core/services/http.service';
import { TimesheetSummary } from './timesheets-store';

export interface TimesheetTaskEntryItem {
    day: number,
    planned: number,
    hours: number
}

export interface TimesheetTaskItem {
    projectTaskId: string,
    title: string,
    entries: TimesheetTaskEntryItem[]
}

export interface TimesheetItem extends TimesheetSummary {
    tasks: TimesheetTaskItem[]
}

export interface EmployeeReport {
    employeeId: string,
    employeeName: string,
    workedHoursPerTask: Map<string, number>,
    workedHoursPerTaskByMonth: Map<string, number[]>,
    workedHoursPerProject: Map<string, number>,
    workedHoursPerProjectByMonth: Map<string, number[]>,
    totalWorkedHours: number,
    totalWorkedHoursByMonth: number[],
    estimatedHourlyCost: number,
}

export interface EmployeesReport {
    reports: EmployeeReport[];
    projectIdToName: Map<string, string>;
    projectTaskIdToName: Map<string, string>;
    fromDateStamp: number;
    toDateStamp: number;
    projectTasks: string[];
    projectIdToCir: Map<string, boolean>;
    projectIdToCii: Map<string, boolean>;
    taskIdToCir: Map<string, boolean>;
    taskIdToCii: Map<string, boolean>;
    tasksToProjects: Map<string, string>;
}

@repository("@@EMPLOYEESREPORT", "employeesReport.summary")
export class EmployeesReportStore extends DataStore<EmployeesReport> {
    baseUrl: string = ``;

    constructor() {
        super('EMPLOYEESREPORT', {
            count: 0,
            isBusy: false,
            items: [],
            result: undefined,
            discard: item => { }
        }, container);
    }

    public changeUrlByAdminProject(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/admin/companies/${companyId}/timesheets/report/${projectId}`;
    }
    public changeUrlByUserProject(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/timesheet/${companyId}/report/${projectId}`;
    }
    public changeUrlByAdminElegibility(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/admin/companies/${companyId}/timesheets/report/elegibility`;
    }
    public changeUrlByUserElegibility(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/timesheet/${companyId}/report/elegibility`;
    }
    public changeAdminUrlByCompany(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/admin/companies/${companyId}/timesheets/report/employees`;
    }
    public changeUserUrlByCompany(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/timesheet/${companyId}/report/employees`;
    }
    public changeUserUrlBase(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/employees`;
    }

    public async getAsync(timesheetsQuery: Query, data?: any): Promise<AxiosResponse<EmployeesReport>> {
        let httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LIST_UPDATE as string, httpService.get<EmployeesReport>(`${this.baseUrl}?${DataStore.buildUrl(timesheetsQuery)}`, data));
        return result;
    }

    public async getEmployeesRoles(userId: string): Promise<string[]> {
        let httpService = this.container.get<HttpService>(HttpService);
        const result = await httpService.get<string[]>(`${this.baseUrl}/EmployeeRoles/${userId}`, {});
        return result.data;
    }
    
}
